import { render, staticRenderFns } from "./Boleto.vue?vue&type=template&id=db1295dc&"
import script from "./Boleto.vue?vue&type=script&lang=js&"
export * from "./Boleto.vue?vue&type=script&lang=js&"
import style0 from "./Boleto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Boleto.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db1295dc')) {
      api.createRecord('db1295dc', component.options)
    } else {
      api.reload('db1295dc', component.options)
    }
    module.hot.accept("./Boleto.vue?vue&type=template&id=db1295dc&", function () {
      api.rerender('db1295dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/steps/PaymentMethods/Boleto.vue"
export default component.exports